import { If, location, onMount, reactive } from 'cdui-js';
import { fetchCrsLatest } from '../../../api/crs';
import i18n from '../../../i18n';
import {
  ResultPendingIcon,
  ResultSuccessIcon,
  ResultWarningIcon,
} from '../account/result/icons';
import { bootDepositApp, isFundHideNav } from '../deposit/h5-deposit/appBridge';
import {
  CRS_RESULT_KIND,
  crsResultKindFromStatus,
  type CrsResultKind,
} from './constants';
import { CrsNav } from './Nav';
import {
  crsFormPath,
  leaveCrs,
  parseCrsRejectReason,
  readCrsResultKindQuery,
  syncCrsAppShell,
} from './shared';
import './page.css';

/** CRS 登记结果页：审核中 / 已完成 / 已拒绝 */
export const CrsSubmittedPage = () => {
  const state = reactive({
    kind: CRS_RESULT_KIND.DONE as CrsResultKind,
    rejectReason: '',
    ready: false,
  });

  onMount(async () => {
    syncCrsAppShell();

    const fromQuery = readCrsResultKindQuery();
    if (fromQuery) {
      state.kind = fromQuery;
      state.ready = true;
    }

    await bootDepositApp();

    try {
      const latest = await fetchCrsLatest();
      const record = latest?.record;
      const statusKind = crsResultKindFromStatus(String(record?.status || ''));
      // query 仅作首屏提示；以 latest 为准（拒绝原因必须从 remark 拉）
      if (statusKind) state.kind = statusKind;
      if (state.kind === CRS_RESULT_KIND.REFUSED) {
        state.rejectReason = parseCrsRejectReason(record?.remark);
      }
    } catch {
      // 无 latest 时保留 query / 默认完成态
    } finally {
      state.ready = true;
    }
  });

  const isPending = () => state.kind === CRS_RESULT_KIND.PENDING;
  const isRefused = () => state.kind === CRS_RESULT_KIND.REFUSED;
  const isDone = () => state.kind === CRS_RESULT_KIND.DONE;

  const titleText = () => {
    if (isPending()) return i18n.Crs.PendingTitle;
    if (isRefused()) return i18n.Crs.RefusedTitle;
    return i18n.Crs.SubmittedTitle;
  };

  const descText = () => {
    if (isPending()) return i18n.Crs.PendingDesc;
    if (isRefused()) return state.rejectReason;
    return i18n.Crs.SubmittedDesc;
  };

  const onReapply = () => {
    location.routeTo(crsFormPath({ reapply: '1' }), [0, 0]);
  };

  return (
    <div class="crs-h5 crs-h5-submitted">
      <If when={!isFundHideNav()}>
        <CrsNav title={i18n.Crs.Title} onBack={leaveCrs} />
      </If>

      <If when={state.ready}>
        <div class="crs-success-body">
          <div class="crs-success-icon">
            <If when={isPending()}>
              <ResultPendingIcon />
            </If>
            <If when={isRefused()}>
              <ResultWarningIcon />
            </If>
            <If when={isDone()}>
              <ResultSuccessIcon />
            </If>
          </div>
          <div class="crs-success-title color-D font-s-L">{titleText()}</div>
          <If when={!!descText()}>
            <div class="crs-success-desc color font-s-S">{descText()}</div>
          </If>
        </div>
      </If>

      <If when={state.ready && isDone()}>
        <div class="crs-foot">
          <button type="button" class="crs-primary-btn" onclick={leaveCrs}>
            {i18n.Crs.Done}
          </button>
        </div>
      </If>

      <If when={state.ready && isRefused()}>
        <div class="crs-foot">
          <button type="button" class="crs-primary-btn" onclick={onReapply}>
            {i18n.Crs.Reapply}
          </button>
        </div>
      </If>
    </div>
  );
};
